// Generated by CoffeeScript 1.12.7
(function() {
  var ansiRegex, isString;

  isString = require('./Core/Types').isString;

  module.exports = {
    ansiRegex: ansiRegex = /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g,
    stripAnsi: function(str) {
      if (ansiRegex.test(str)) {
        return str.replace(ansiRegex, '');
      } else {
        return str;
      }
    },
    ansiSafeStringLength: function(str) {
      if (!isString(str)) {
        throw new Error("not string");
      }
      if (ansiRegex.test(str)) {
        str = str.replace(ansiRegex, '');
      }
      return str.length;
    }
  };

}).call(this);

//# sourceMappingURL=Ansi.js.map
